// in AddManyLicensesDialog.js
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { Toolbar, SaveButton, ArrayInput, SimpleFormIterator, ReferenceInput, AutocompleteInput, NumberInput, BooleanInput, SimpleForm, TextInput, useNotify, useRefresh } from 'react-admin';
import { useState } from 'react';
import { useDataProvider } from 'react-admin';

const emailFilterToQuery = email => ({ email: email });
const productFilterToQuery = name => ({ name: name})

const AddManyLicensesDialog = ({ open, onClose }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [loading, setLoading] = useState(false);
  const [submitReady, setSubmitReady] = useState(true);
  const dataProvider = useDataProvider();



  const handleSubmit = async (data) => {
    let duration_iso = 'P';
    if (data.durationYears > 0) { duration_iso += `${data.durationYears}Y` }
    if (data.durationMonths > 0) { duration_iso += `${data.durationMonths}M` }
    if (data.durationDays > 0) { duration_iso += `${data.durationDays}D` }
    delete data.durationYears;
    delete data.durationMonths;
    delete data.durationDays;

    if (duration_iso != 'P') {  // no duration == perpetual
        data.durationIso = duration_iso;
    }

    data.productSkuIdList = data.productSkuIdList?.map(p => p.productSkuId)
    data.userIdList = data.userIdList?.map(u => u.userId)

    setLoading(true);
    try {
        console.log(data);
        await dataProvider.addManyLicenses(data);
      notify('Licenses added successfully', { type: 'success' });
      refresh();
      onClose();
    } catch (error) {
      notify(`Error: ${error.message}`, { type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const DialogToolbar = () => (
    <Toolbar>
      <SaveButton
        label="Submit"
        disabled={loading}
        alwaysEnable
      />
      <Button onClick={onClose} disabled={loading}>
        Cancel
      </Button>
    </Toolbar>
  );

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Add Many Licenses</DialogTitle>
      <DialogContent>
        <SimpleForm onSubmit={handleSubmit} toolbar={<DialogToolbar />}>
            
            <TextInput source="subject" defaultValue="" fullWidth/>
            
            <div>
                <NumberInput source="durationYears" defaultValue={0} />
                <NumberInput source="durationMonths" defaultValue={0} />
                <NumberInput source="durationDays" defaultValue={0} />
            </div>
            
            <NumberInput source="numSeats" defaultValue={1}/>
            <BooleanInput label="Are these Trial licenses?" source="isTrial" />

            <ArrayInput source="productSkuIdList">
                <SimpleFormIterator inline fullWidth>
                    <ReferenceInput label="ProductSku" source="productSkuId" reference="product-skus">
                        <AutocompleteInput
                            optionText="name"
                            suggestionLimit="20"
                            filterToQuery={productFilterToQuery}
                            fullWidth
                        />
                    </ReferenceInput>
                </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="userIdList" >
                <SimpleFormIterator inline fullWidth>
                    <ReferenceInput label="User" source="userId" reference="users">
                        <AutocompleteInput
                            optionText="email"
                            suggestionLimit="5"
                            filterToQuery={emailFilterToQuery}
                            fullWidth
                        />
                    </ReferenceInput>
                </SimpleFormIterator>
            </ArrayInput>
        </SimpleForm>
      </DialogContent>
    </Dialog>
  );
};

export default AddManyLicensesDialog;
